import { PipeAgoPipe } from './pipes/pipe-ago.pipe';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [PipeAgoPipe],
  exports: [PipeAgoPipe]
})
export class PipeModule {
  static forRoot() {
    return {
      ngModule: PipeModule,
      providers: []
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/pipe.module.ts